// =====================================================
// 포인트관리 — 탭: 적립/사용 내역 · 적립 관리 · 사용 관리
// =====================================================
import { useState } from 'react'
import AdminPointHistoryList from './AdminPointHistoryList'
import EarnRuleTab from './EarnRuleTab'
import UsageTypeTab from './UsageTypeTab'

const TABS = [
  { key: 'history', label: '적립/사용 내역' },
  { key: 'earn', label: '적립 관리' },
  { key: 'usage', label: '사용 관리' },
] as const

type TabKey = typeof TABS[number]['key']

export default function AdminPointManagement() {
  const [activeTab, setActiveTab] = useState<TabKey>('history')

  return (
    <div className="bg-[#f5f2f0] min-h-screen p-8">
      <div className="max-w-[1200px] mx-auto">

        {/* 헤더 */}
        <div className="mb-6">
          <h1 className="text-[22px] font-extrabold text-[#2a1f1a] mb-1">포인트관리</h1>
          <p className="text-[13px] text-gray-400">
            {new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' })}
          </p>
        </div>

        {/* 탭 */}
        <div className="flex gap-2 mb-5 bg-white rounded-2xl p-1.5 border border-[#e8e0dc] w-fit shadow-[0_2px_12px_rgba(136,114,103,0.06)]">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={[
                'px-5 py-2 rounded-xl text-[13px] font-semibold transition-colors',
                activeTab === tab.key
                  ? 'bg-[#887267] text-white'
                  : 'text-gray-400 hover:text-[#887267]',
              ].join(' ')}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === 'history' && <AdminPointHistoryList />}
        {activeTab === 'earn' && <EarnRuleTab />}
        {activeTab === 'usage' && <UsageTypeTab />}
      </div>
    </div>
  )
}
